/* eslint-disable no-restricted-imports */
import { LD_JSON_SCRIPT_TYPE } from '@/components/blocks/MetadataScript/constants';
import { getPDPMetaData } from '@/components/content/ProductDetails/parts/MetadataScriptPDP/utils';
import { ProductType } from '@/data/types/Product';
import { getStoreDataByPhysicalStoreId } from '@/data/utils/commonIntegrationUtils';
import { useCurrentPhysicalStoreId } from '@/utils/useCurrentPhysicalStoreId';
import { useSearchParams } from 'next/navigation';
import Script from 'next/script';
import { DEFAULT_STORE_ID, PAGES_METADATA } from 'shared/custom/constants/commonConstants';

export interface MetadataScriptPDPProps {
	product: ProductType | undefined;
}

const page = PAGES_METADATA.PDP;

export const MetadataScriptPDP = ({ product }: MetadataScriptPDPProps) => {
	const params = useSearchParams();
	const physicalStoreIdFromSearchParams = params?.get('store_code') ?? '';

	const { physicalStoreId: physicalStoreIdFromHook } = useCurrentPhysicalStoreId({
		defaultPhysicalStoreId: DEFAULT_STORE_ID,
	});

	const store =
		getStoreDataByPhysicalStoreId(physicalStoreIdFromSearchParams) ??
		getStoreDataByPhysicalStoreId(physicalStoreIdFromHook ?? DEFAULT_STORE_ID);

	if (!product || !store) return null;

	const { marketId, stLocId: physicalStoreId } = store;

	return getPDPMetaData({ product, marketId, physicalStoreId })?.map((script, index) => (
		<Script
			id={`__metadata_script_${page}_${index}`}
			strategy="beforeInteractive"
			key={page + index}
			type={LD_JSON_SCRIPT_TYPE}
			dangerouslySetInnerHTML={{
				__html: JSON.stringify(script),
			}}
		/>
	));
};
